(function () {
  'use strict';

  const panel      = document.getElementById('mega-search-panel');
  const overlay    = document.getElementById('mega-search-overlay');
  const trigger    = document.getElementById('mega-search-trigger');
  const closeBtn   = document.getElementById('mega-search-close');
  const input      = panel ? panel.querySelector('.mega-search__input') : null;
  const resetBtn   = panel ? panel.querySelector('.mega-search__reset-btn') : null;
  const defaultEl  = document.getElementById('mega-search-default');
  const liveEl     = document.getElementById('mega-search-live-results');
  const viewAllBtn = document.getElementById('mega-search-view-all');
  const footer     = document.getElementById('mega-search-footer');

  if (!panel || !trigger) return;

  // ── Transparent header helpers ──

  function getHeaderWrapper() {
    return document.querySelector('.header-wrapper');
  }

  function forceHeaderSolid() {
  const hw = getHeaderWrapper();
  if (!hw) return;
  hw.setAttribute('data-search-open', 'true');

  if (hw.classList.contains('header-wrapper--transparent')) {
    const scrollY = parseInt(document.body.dataset.scrollY || window.pageYOffset || 0);
    
    // Always make header solid when search opens
    hw.classList.add('is-scrolled');

    const mainLogo = hw.querySelector('.main-logo');
    const transparentLogo = hw.querySelector('.transparent-logo');

    if (scrollY <= 10) {
      // Page is at top — panel bg is dark maroon → show WHITE logo
      if (mainLogo) mainLogo.style.setProperty('display', 'none', 'important');
      if (transparentLogo) transparentLogo.style.setProperty('display', 'block', 'important');
    } else {
      // Page was already scrolled — header was already solid with default logo
      // Keep default logo, just remove any overrides
      if (mainLogo) mainLogo.style.removeProperty('display');
      if (transparentLogo) transparentLogo.style.removeProperty('display');
    }
  }
}

  function restoreHeaderTransparency() {
    const hw = getHeaderWrapper();
    if (!hw) return;
    hw.removeAttribute('data-search-open');

    if (hw.classList.contains('header-wrapper--transparent')) {
      // Read the REAL scroll position (body.scrollY was saved before lock)
      const scrollY = parseInt(document.body.dataset.scrollY || window.pageYOffset || 0);
      const mainLogo = hw.querySelector('.main-logo');
      const transparentLogo = hw.querySelector('.transparent-logo');

      // Always remove inline styles — let CSS rules take over
      if (mainLogo) mainLogo.style.removeProperty('display');
      if (transparentLogo) transparentLogo.style.removeProperty('display');

      if (scrollY <= 10) {
        // Page was at top — go back to transparent state → CSS shows white logo
        hw.classList.remove('is-scrolled');
      } else {
        // Page was scrolled — keep solid state → CSS shows default (maroon) logo
        hw.classList.add('is-scrolled');
      }
    }
    // Non-transparent pages: do nothing — CSS handles it correctly already
  }

  
  // ── Open / close helpers ──

  function openPanel() {
    panel.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-visible');
    trigger.setAttribute('aria-expanded', 'true');

    // ── STEP 1: Save scroll position FIRST before anything else ──
    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.dataset.scrollY = scrollY; // saved BEFORE forceHeaderSolid reads it

    // ── STEP 2: Now forceHeaderSolid can correctly read dataset.scrollY ──
    forceHeaderSolid();

    // ── STEP 3: Position the panel based on saved scroll ──
    if (scrollY > 10) {
      panel.style.top = '99px';
    } else {
      panel.style.top = '124px';
    }

    if (input) {
      setTimeout(() => input.focus(), 50);
    }
  }

  function closePanel() {
    panel.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-visible');
    trigger.setAttribute('aria-expanded', 'false');

    // Restore scroll position properly
    const scrollY = parseInt(document.body.dataset.scrollY || 0);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    delete document.body.dataset.scrollY;
    window.scrollTo(0, scrollY);

    panel.style.top = '';
    restoreHeaderTransparency();
  }

  // ── Default ↔ live results switching ──

  function showDefaultState() {
    if (defaultEl) defaultEl.style.display = '';
    if (liveEl)    liveEl.style.display = 'none';
    if (footer)    footer.style.display = '';
  }

  function showLiveResults() {
    if (defaultEl) defaultEl.style.display = 'none';
    if (liveEl)    liveEl.style.display = '';
    if (footer)    footer.style.display = '';
  }

  // ── Update "View All Results" href ──

  function updateViewAllHref(term) {
    if (!viewAllBtn) return;
    const base = viewAllBtn.getAttribute('href').split('?')[0];
    viewAllBtn.setAttribute('href', base + '?q=' + encodeURIComponent(term || ''));
  }

  // ── Event listeners ──

  trigger.addEventListener('click', () => {
    const isOpen = panel.getAttribute('aria-hidden') === 'false';
    if (isOpen) {
      closePanel();
    } else {
      openPanel();
    }
  });

  if (closeBtn) closeBtn.addEventListener('click', closePanel);
  if (overlay)  overlay.addEventListener('click', closePanel);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.getAttribute('aria-hidden') === 'false') {
      closePanel();
    }
  });

  // ── Input change: show/hide live results ──

  if (input) {
    input.addEventListener('input', function () {
      const val = this.value.trim();
      updateViewAllHref(val);

      if (resetBtn) {
        resetBtn.classList.toggle('hidden', val.length === 0);
      }

      if (val.length === 0) {
        showDefaultState();
      } else {
        showLiveResults();
      }
    });
  }

  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      if (input) {
        input.value = '';
        input.focus();
        // Also clear the predictive-search component's internal state
        const ps = panel.querySelector('predictive-search');
        if (ps && typeof ps.onFormReset === 'function') {
          ps.onFormReset(new Event('reset'));
        }
      }
      resetBtn.classList.add('hidden');
      showDefaultState();
      updateViewAllHref('');
    });
  }

  // ── Patch PredictiveSearch to render into our live results div ──

  function patchPredictiveSearch() {
    const predictiveSearchEl = panel.querySelector('predictive-search');
    if (!predictiveSearchEl) return;

    // Patch renderSearchResults to write into OUR liveEl container
    const originalRender = predictiveSearchEl.renderSearchResults?.bind(predictiveSearchEl);
    if (originalRender) {
      predictiveSearchEl.renderSearchResults = function (resultsMarkup) {
        // Write results into the mega-search live container
        if (liveEl) {
          liveEl.innerHTML = resultsMarkup;
        }
        // Keep internal state consistent
        this.setAttribute('results', true);
        this.removeAttribute('loading');
        // Update the live region text
        const liveRegionEl = liveEl
          ? liveEl.querySelector('[data-predictive-search-live-region-count-value]')
          : this.querySelector('[data-predictive-search-live-region-count-value]');
        if (liveRegionEl && this.statusElement) {
          this.setLiveRegionText(liveRegionEl.textContent);
        }
        // Show our live results panel
        if (input && input.value.trim().length > 0) {
          showLiveResults();
        }
        this.open();
      };
    }

    // Patch open() so it doesn't set maxHeight on an irrelevant element
    predictiveSearchEl.open = function () {
      this.setAttribute('open', true);
      if (this.input) this.input.setAttribute('aria-expanded', true);
      this.isOpen = true;
      // No maxHeight manipulation — our panel handles its own layout
    };

    // Patch close() so closing predictive search doesn't hide our panel
    predictiveSearchEl.close = function (clearSearchTerm = false) {
      this.closeResults(clearSearchTerm);
      this.isOpen = false;
      if (clearSearchTerm) {
        showDefaultState();
      }
    };

    // Patch closeResults to clear our liveEl too
    const originalCloseResults = predictiveSearchEl.closeResults?.bind(predictiveSearchEl);
    if (originalCloseResults) {
      predictiveSearchEl.closeResults = function (clearSearchTerm = false) {
        if (clearSearchTerm) {
          this.input.value = '';
          this.removeAttribute('results');
          if (liveEl) liveEl.innerHTML = '';
        }
        const selected = this.querySelector('[aria-selected="true"]');
        if (selected) selected.setAttribute('aria-selected', false);
        this.input.setAttribute('aria-activedescendant', '');
        this.removeAttribute('loading');
        this.removeAttribute('open');
        this.input.setAttribute('aria-expanded', false);
        this.resultsMaxHeight = false;
        // Don't manipulate predictiveSearchResults style — we use our own container
      };
    }
  }

  // Patch as soon as the element is ready — either already upgraded or wait for it
  if (customElements.get('predictive-search')) {
    patchPredictiveSearch();
  } else {
    customElements.whenDefined('predictive-search').then(patchPredictiveSearch);
  }

})();